import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'antd-mobile';
import useZoom from '@/hooks/useZoom';
import useXState from '@/hooks/useXState';
import { Context } from '../../index';
import { SINGLE, MULT, getImgFormSiteInfo } from './imgUtils';
import Bus from '../context/bus';
import { ReplaceText, TLang } from '@/utils/lang';
const styles = require('./style/index.less');

const WIDTH = 128;
const HEIGHT = 104;
let SET_WIDTH = 128;
let SET_HEIGHT = 104;
let firstZoomFlag = true;
const SitCanvas = (props) => {
  // 座位图，缩放，选中回调， 可选最多座位数， 是否单票价  normal 普通状态
  const { data, getZoom, getAreaScale, getSeledSit, maxSit, zoomTarget, activeIndex } = props;
  const canvas: any = useRef(null);
  const ctx: any = useRef(null);
  const [seledSit, setSeledSit] = useXState([]);
  // const [seledSit, setSeledSit] = useXState(state.value)
  const [sitData, setSitData] = useState(data);

  useEffect(() => {
    setSitData(data);
  }, [data]);

  let isMult = true;

  const [stop] = useZoom(
    zoomTarget,
    canvas,
    (e, { size, firstZoom }) => {
      if (firstZoom) {
        SET_WIDTH = Math.floor(WIDTH * size);
        SET_HEIGHT = Math.floor(HEIGHT * size);
      }
      firstZoomFlag = firstZoom;
      getZoom(size);
    },
    (e, { size }) => {
      let _WIDTH = Math.floor(WIDTH * size);
      let _HEIGHT = Math.floor(HEIGHT * size);
      if (_WIDTH !== SET_WIDTH || _HEIGHT !== SET_HEIGHT) {
        // const fn = throttle(() => {
        SET_WIDTH = _WIDTH;
        SET_HEIGHT = _HEIGHT;
        getZoom(size);
        // }, 10);
        // fn();
      }
    },
    (e, { size }) => {
      SET_WIDTH = Math.floor(WIDTH * size);
      SET_HEIGHT = Math.floor(HEIGHT * size);
      getZoom(size);
    },
    ({ size }) => {
      // 初始化缩放
      SET_WIDTH = Math.floor(WIDTH * size);
      SET_HEIGHT = Math.floor(HEIGHT * size);
      getZoom(size);
    },
    [0.8],
    {
      row: data[0].length,
      col: data.length
    },
  );

  // 一定要更新监听，否则 delItem 删除后不会同步
  useEffect(() => {
    canvas.current.addEventListener('click', clickHandler, {
      passive: false
    });
    return () => {
      canvas.current.removeEventListener('click', clickHandler);
    };
  }, []);

  useEffect(() => {
    Bus.addListener('deleSeat', delItem);
    return () => {
      Bus.removeListener('deleSeat', delItem);
    };
  }, []);

  const delItem = (index) => {
    // console.log('delItem',index);
    let idx = index;
    let currentNum = seledSit[index]; // 判断提交的座位是否已被选中
    // 13 2     id: "3-14",  数据改成了 x列 y排
    let xy = currentNum.id.split('-'); //
    const pageY = xy[1] - 1;
    const pageX = xy[0] - 1;
    // console.log(currentNum,xy);
    if (currentNum.state === 2) {
      currentNum.state = currentNum.originState;
      seledSit.splice(idx, 1); // 选中删除
      sitData[pageY][pageX] = currentNum;
    } else if (currentNum.state === 6) {
      currentNum.state = currentNum.originState;
      if (currentNum.position === 0) {
        sitData[pageY][pageX].state = currentNum.state;
        sitData[pageY][pageX + 1].state = currentNum.state;
        seledSit.splice(idx, 2); // 选中删除
      } else {
        sitData[pageY][pageX].state = currentNum.state;
        sitData[pageY][pageX - 1].state = currentNum.state;
        seledSit.splice(idx - 1, 2); // 选中删除
      }
    }
    // console.log('delItem',seledSit,sitData)
    setSeledSit([...seledSit], () => {
      // dispatch({type:"CHANG_SIT",value:seledSit})
      getSeledSit(seledSit, sitData);
    });
    setSitData([...sitData]);
  };
  useEffect(() => {
    // 初始化
    if (ctx.current === null) {
      ctx.current = canvas.current.getContext('2d');
      canvas.current.width = SET_WIDTH * data[0].length;
      canvas.current.height = SET_HEIGHT * data.length;
      // console.log('w',(SET_WIDTH * data[0].length),'h',(SET_HEIGHT * data.length))
      canvas.current.style.width = `${canvas.current.width / 2}px`;
      canvas.current.style.height = `${canvas.current.height / 2}px`;
    }
  }, [canvas]);

  useEffect(() => {
    // if(ctx.current){
    //   let width = (SET_WIDTH * data[0].length)
    //   let height = (SET_HEIGHT * data.length)
    //   ctx.current.clearRect(0,0,width,height)
    // }
    canvas.current.width = SET_WIDTH * data[0].length;
    canvas.current.height = SET_HEIGHT * data.length;
    canvas.current.style.width = `${canvas.current.width / 2}px`;
    canvas.current.style.height = `${canvas.current.height / 2}px`;
    // 计算 宽高比例
    getAreaScale({ w: canvas.current.style.width, h: canvas.current.style.height });
    sitData.map((coloum, index) => {
      coloum.map((ele, idx) => {
        let img = new Image();

        img = SINGLE.UNSELED;
        if (ele.state === 0) {
          img = SINGLE.EMPTY;
        } else if (ele.state > 100 && ele.state < 200) {
          // 分 单票价个多票价[高亮还是暗色]
          img = getImgFormSiteInfo(ele.state, activeIndex);
        } else if (ele.state === 1) {
          img = SINGLE.UNSELED;
        } else if (ele.state === 2) {
          img = SINGLE.SELED;
        } else if (ele.state === 3) {
          img = SINGLE.FIX;
        } else if (ele.state === 4) {
          img = SINGLE.SALED;
        } else if (ele.state > 400 && ele.state < 500) {
          if (isMult) {
            img = MULT.SALED[0];
            isMult = false;
            ele.position = 0;
          } else {
            img = MULT.SALED[1];
            isMult = true;
            ele.position = 1;
          }
        } else if (ele.state > 500 && ele.state < 600) {
          // 分 单票价个多票价[高亮还是暗色]
          if (isMult) {
            img = getImgFormSiteInfo(ele.state, activeIndex)[0];
            isMult = false;
            ele.position = 0;
          } else {
            img = getImgFormSiteInfo(ele.state, activeIndex)[1];
            isMult = true;
            ele.position = 1;
          }
        } else if (ele.state === 5) {
          if (isMult) {
            img = MULT.UNSELED[0];
            isMult = false;
            ele.position = 0;
          } else {
            img = MULT.UNSELED[1];
            isMult = true;
            ele.position = 1;
          }
        } else if (ele.state === 6) {
          if (isMult) {
            img = MULT.SELED[0];
            isMult = false;
            ele.position = 0;
          } else {
            img = MULT.SELED[1];
            isMult = true;
            ele.position = 1;
          }
        }

        if (!img.complete) {
          img.addEventListener('load', (e) => {
            ctx.current.drawImage(img, idx * SET_WIDTH, index * SET_HEIGHT, SET_WIDTH, SET_HEIGHT);
          });
        } else {
          let idd = index;
          ctx.current.drawImage(img, idx * SET_WIDTH, idd * SET_HEIGHT, SET_WIDTH, SET_HEIGHT);
        }
      });
    });
  }, [sitData, SET_WIDTH, SET_HEIGHT, canvas, activeIndex]);

  const clickHandler = (e) => {
    e.preventDefault();
    if (firstZoomFlag) {
      return;
    }
    let offset = canvas.current.getBoundingClientRect();
    let pageX = Math.floor((e.pageX - offset.left) / (SET_WIDTH / 2));
    let pageY = Math.floor((e.pageY - offset.top) / (SET_HEIGHT / 2));
    let currentSit = sitData[pageY][pageX];
    if (currentSit) {
      function checkSea(currentNum) {
        let idx = seledSit.findIndex((ele) => currentNum.id === ele.id); // 判断提交的座位是否已被选中
        if (idx >= 0) {
          if (currentNum.state === 2) {
            currentNum.state = currentNum.originState;
            seledSit.splice(idx, 1); // 选中删除
          } else if (currentNum.state === 6) {
            currentNum.state = currentNum.originState;
            if (currentNum.position === 0) {
              sitData[pageY][pageX + 1].state = currentNum.state;
              seledSit.splice(idx, 2); // 选中删除
            } else {
              sitData[pageY][pageX - 1].state = currentNum.state;
              seledSit.splice(idx - 1, 2); // 选中删除
            }
          }
        } else {
          if (
            seledSit.length >= maxSit ||
            (seledSit.length == maxSit - 1 &&
              ((currentNum.state > 500 && currentNum.state < 600) || currentNum.state === 5))
          ) {
            Toast.info(`${ReplaceText('X', maxSit, TLang('最多可选X个座位', 'home', false, false, null), false)}`, 2);
            return;
          }
          if (currentNum.state === 1) {
            currentNum.state = 2;
            seledSit.push({ ...currentNum }); // 没选中则加入选中array
          } else if (currentNum.state > 100 && currentNum.state < 200) {
            currentNum.state = 2;
            seledSit.push({ ...currentNum }); // 没选中则加入选中array
          } else if ((currentNum.state > 500 && currentNum.state < 600) || currentNum.state === 5) {
            currentNum.state = 6;
            if (currentNum.position === 0) {
              sitData[pageY][pageX + 1].state = 6;
              seledSit.push({ ...currentNum });
              seledSit.push({ ...sitData[pageY][pageX + 1] });
            } else {
              sitData[pageY][pageX - 1].state = 6;
              seledSit.push({ ...sitData[pageY][pageX - 1] });
              seledSit.push({ ...currentNum });
            }
          }
        }
        setSeledSit([...seledSit], () => {
          // dispatch({type:"CHANG_SIT",value:seledSit})
          getSeledSit(seledSit, sitData); // 选中的座位传出去
        });
        setSitData([...sitData]); // 更新canvas
      }
      checkSea(currentSit);
    }
  };

  return <canvas ref={canvas} />;
};

export default SitCanvas;
